import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import prototypes from "../data/prototypes";
import { useHistory, Link } from "react-router-dom";

export default function Prototipo(props) {
    let history = useHistory();

    function handleContactanos() {
        history.push("/Contact");
    }

    return (
        <Fragment>
            <Helmet>
                <title>Prototipo ~ Antigua Finca San Cristobal</title>
            </Helmet>

            <div className="dark:bg-gray-800 pt-52">
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
                    {prototypes.map((item) => (
                        <div key={item.id} className="text-center">
                            <img className="rounded shadow-lg mx-auto" src={item.image2} alt={item.name} />
                            <div className="relative z-0 p-4">
                                <Link to={`/prototipo/${item.id}`}>
                                    <button className="border pt-1 pb-1 px-6 constantine font-light text-white uppercase hover:bg-white hover:border-corn hover:text-corn text-xl">
                                        <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                                            {item.name}
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* <div className="dark:bg-gray-800">
                <div className="container mx-auto">
                    
                    {prototypes.map((proto) => (
                        <div key={proto.id} id={proto.id} className="py-16">
                            <div className="text-center pb-12 pt-16">
                                <h3 className="mt-2 text-3xl leading-8 tracking-tight sm:text-4xl constantine text-center pb-5">
                                    <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                                        {proto.name}
                                    </span>
                                </h3>
                                <h1 className="text-center volk font-light text-2xl uppercase">
                                    <span className="block bg-gradient-to-r from-elf via-elf to-cyprus dark:from-elf dark:via-elf dark:to-white bg-clip-text text-transparent uppercase">
                                        {proto.description}
                                    </span>
                                </h1>
                            </div>
                            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                                <div
                                    className="mx-auto"
                                    data-aos="fade-up-right"
                                    data-aos-duration="1000"
                                >
                                    <img src={proto.image} alt={proto.name} className="max-w-lg mx-auto" />
                                </div>
                                <div>
                                    <div className="pt-12 p-5 lg:p-10">
                                        <h3 className="mt-2 text-3xl leading-8 tracking-tight sm:text-4xl constantine text-center pb-5">
                                            <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                                                <HomeIcon fontSize="large" /> Modelo de la casa
                                            </span>
                                        </h3>
                                        <h1 className="text-center volk font-light text-2xl uppercase">
                                            <span className="block bg-gradient-to-r from-elf via-elf to-cyprus dark:from-elf dark:via-elf dark:to-white bg-clip-text text-transparent uppercase">
                                                Conoce el diseño de este prototipo
                                            </span>
                                        </h1>
                                        <div className="mt-10">
                                            <div className="mt-2 mb-6">
                                                <h3 className="mt-2 text-3xl leading-8 tracking-tight sm:text-4xl constantine text-center pb-5">
                                                    <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                                                        {proto.model}
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className="md:grid gap-4 md:grid-cols-2">
                                                {proto.features.map((feature, index) => (
                                                    <div key={index}>
                                                        <p className="noto p-2 rounded hover:bg-tango-500 hover:text-white cursor-pointer iconHover text-gray-700 dark:text-gray-300">
                                                            <feature.icon className="text-tango-500 -mt-1" />
                                                            <span className="p-2 mt-2 raleway">{feature.text}</span>
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}


            {/* <div className="pt-20 pb-10 dark:bg-gray-800">
                <Carousel />
            </div> */}
            {/* <div className="bg-gray-50 dark:bg-gray-700 p-10">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div data-aos="fade-up-right" data-aos-duration="1000">
                            <img src="img/Nivel.png" alt="Nivel" />
                        </div>
                        <div data-aos="fade-up-left" data-aos-duration="1000">
                            <img src="img/Nivel.png" alt="Nivel" />
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="bg-white dark:bg-gray-800">
                <div className="max-w-7xl mx-auto pb-20">
                    <div className="max-w-3xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8" data-aos="fade-up" data-aos-duration="1000">
                        <h2 className="text-5xl text-sycamore constantine">
                            <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                                ¡Estas a un paso de iniciar!
                            </span>
                        </h2>
                        <button onClick={handleContactanos} className="bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn text-white dark:text-brown mt-10 pt-3 pb-3 pr-12 px-12 constantine font-light uppercase hover:from-mule hover:via-corn hover:to-brown">Contáctanos</button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}